import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	turnAutoHeartbeatButton: {
		id: 'eoc.heartbeats.empty-state.secondary-action.no-translate',
		defaultMessage: '{isEnabled, select, true {Turn off} other {Turn on}} auto-heartbeats',
		description: 'Text of secondary empty state button used to turn on auto heartbeat creation.',
	},
});

export default messages;
